import Reveal from "@/components/base/Reveal";
import { novelIntro, novelMeta } from "@/mocks/home";

export default function NovelIntro() {
  return (
    <section id="intro" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.28em] uppercase text-primary-600">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                作品简介
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-snug text-foreground-950">
                关于《迷人的保姆》
              </h2>
            </Reveal>

            <Reveal delay={80}>
              <div className="mt-6 space-y-5">
                {novelIntro.paragraphs.map((paragraph) => (
                  <p
                    key={paragraph.slice(0, 12)}
                    className="text-sm md:text-base leading-[1.9] text-foreground-700"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </Reveal>

            <Reveal delay={140}>
              <div className="mt-8 flex flex-wrap gap-2">
                {novelMeta.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-label text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={120}>
              <div className="relative w-full h-[260px] md:h-[320px] rounded-lg overflow-hidden border border-background-300/70 bg-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20quiet%20reading%20nook%20illustration%20with%20an%20open%20book%20resting%20on%20a%20wooden%20table%20beside%20a%20cup%20of%20tea%20and%20a%20vase%20of%20dried%20flowers%2C%20warm%20cream%20amber%20and%20sage%20color%20palette%2C%20hand-drawn%20editorial%20illustration%20with%20gentle%20grain%20texture%2C%20calm%20and%20inviting%20atmosphere%2C%20wide%20horizontal%20composition&width=1280&height=853&seq=mb-nanny-reading-02&orientation=landscape"
                  alt="安静的阅读角落插画"
                  title="迷人的保姆 全文阅读氛围插画"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </Reveal>

            <Reveal delay={180}>
              <dl className="mt-6 grid grid-cols-2 gap-x-6 gap-y-5 rounded-lg border border-background-300/60 bg-background-50 p-6">
                {novelIntro.info.map((item) => (
                  <div key={item.label}>
                    <dt className="text-xs font-label tracking-wider text-foreground-500">
                      {item.label}
                    </dt>
                    <dd className="mt-1.5 font-heading text-sm md:text-base text-foreground-900">
                      {item.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}